import React, { useEffect, useState, useContext, useRef } from 'react';
import { Form, Button, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import * as Constants  from '../api/constants';
import { Context } from '../App';
import { useNavigate  } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import AdminDateInput from '../components/AdminDateInput';
import { summarizeBookingPackages } from '../utils/adminBookingPackages';
import '../adminConsoleTheme.css';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { CsvExportModule } from "ag-grid-community";
import { ModuleRegistry } from "ag-grid-community";
import Select from 'react-select';

ModuleRegistry.registerModules([
  CsvExportModule,
]);

const HIDE_FROM_MAIN_DASHBOARD = new Set([
  "ONLINE PAYMENT FAILED",
  "PAYMENT ABANDONED",
  "LAPSE",
]);

function isFailedOnlinePaymentRow(row) {
  if (!row || String(row.paymentMode || "").toUpperCase() !== "ONLINE") return false;
  const st = String(row.paymentStatus || "").toUpperCase();
  if (st === "ADMIN PENDING PAYMENT") return false;
  return HIDE_FROM_MAIN_DASHBOARD.has(st) || st === "SAVE NOW PAY LATER";
}

const AdminDashboard = () => {
    const gridRef = useRef();

    const tableMeta = [
        {headerName: 'Name', field: 'customerName', width: 150},
        {headerName: 'Event', field: 'eventType', width: 120},
        {headerName: 'Contact', field: 'phoneNumber', width: 120},
        {headerName: 'Date', field: 'eventDate', width: 120},
        {headerName: 'Theatre', field: 'theatreName', width: 150},
        {headerName: 'Slot', field: 'slotName', width: 180},
        {headerName: 'Seats', field: 'totalSeats', width: 80},
        {headerName: 'Total Invoice amount', field: 'totalAmount', width: 150},
        {headerName: 'Amount Paid', field: 'totalAmountPaid', width: 150},
        {headerName: 'Payment Mode', field: 'paymentMode', width: 150},
        {headerName: 'Booking Status', field: 'status', width: 120},
        {headerName: 'Payment Status', field: 'paymentStatus', width: 120},
        {headerName: 'Booking Id', field: 'bookingRefId', width: 150},
        {headerName: 'Remaining Amoutn to be Paid', field: 'remainingAmtToPay', width: 180},
        {headerName: 'Decoration', field: 'selectedDecoration', width: 150},
        {headerName: 'Cake', field: 'selectedCake', width: 150},
        {headerName: 'Name on Cake', field: 'userDirections', width: 150},
        {headerName: 'Flowers', field: 'selectedFlowers', width: 150},
        {headerName: 'Party Props', field: 'selectedPartyProps', width: 150},
        {headerName: 'Gifts', field: 'selectedGiftsDetails', width: 150},
        {headerName: 'Photo', field: 'selectedPhotoDetails', width: 150},
        
        
    ];
    const nextDate = new Date(new Date().getFullYear(),new Date().getMonth(), new Date().getDate()+30);

    const [eventDate, setEventDate] = useState(new Date().toISOString().split('T')[0]);
    const [eventToDate, setEventToDate] = useState(nextDate.toISOString().split('T')[0]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [selectedCard, setSelectedCard] = useState({});
    const [data, setData] = useState([]);
    const {context} = useContext(Context);
    const [selectedTheatre, setSelectedTheatre] = useState('');
    const navigate = useNavigate();
    const [availableTimeSlotData, setAvailableTimeSlotData] = useState([]);
    const [fullMetaData, setFullMetaData] = useState(null);
    const [timeSlotObj, setTimeSlotObj] = useState({});
    const [initialSelectedSlotId, setInitialSelectedSlotId] = useState(null);
    const [seatsPrice, setSeatsPrice] = useState(0);
    const [advancePaidTillNow, setAdvancePaidTillNow] = useState(0);
    const [addsOnsPrice, setAddsOnsPrice] = useState(0);

    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    const [cancelPersonName, setCancelPersonName] = useState("");
    const [cancelMessage, setCancelMessage] = useState("");
    const [cancelBusy, setCancelBusy] = useState(false);

    useEffect(() => {
        if (!context.isAdminLoggedIn) {
            navigate('/admin', { replace: true });
        }
    }, [context.isAdminLoggedIn, navigate]);

    const calculateSeatsPrice = () => {
        if(timeSlotObj){
            const selectedSeats = selectedCard.totalSeats;
            const defaultSeats = timeSlotObj.defaultCapacity;
            const extraPerPerson = timeSlotObj.extraPerPerson;
            const basePrice = timeSlotObj.basePrice;
            if(selectedSeats <= defaultSeats){
                setSeatsPrice(basePrice);
            }else{
                const extraSeats = selectedSeats - defaultSeats;
                setSeatsPrice((basePrice) + (extraSeats * extraPerPerson));
            }
        }
    }

    const calculateAddsOnsPrice = () => {
        const eventAddons = selectedCard.eventAddons;
        if (!eventAddons) {
            setAddsOnsPrice(0);
            return;
        }
        let totalAddsOnsPrice = 0;
        for (const key in eventAddons) {
            const selectedAddsOns = eventAddons[key];
            if (!selectedAddsOns) continue;
            for (const addOn of selectedAddsOns) {
                totalAddsOnsPrice += addOn.price;
            }
        }
        setAddsOnsPrice(totalAddsOnsPrice);
    }

    const changeDate = (e) => {
        const date = e.target.value;
        setSelectedCard({
            ...selectedCard,
            eventDate: date,
            theatreId: '',
            slotId: "",
            totalSeats: ''
        });
    }


    const handleSave = () => {
        gridRef.current.api.deselectAll();
        let finalAmountToPay = seatsPrice + addsOnsPrice - selectedCard.totalAmountPaid;
        const mode = String(selectedCard.paymentMode || "").trim();
        if (!mode || mode === "OFFLINE" || mode.toUpperCase() === "PENDING") {
            alert("Payment mode should be Bank or Cash (update from Pending when payment is received).");
            return;
        }
        const payloadObj = {
            paymentMode: selectedCard.paymentMode,
            amountPaid: selectedCard.totalAmountPaid,
            remainingFinalAmount : finalAmountToPay,
            bookingRefId: selectedCard.bookingRefId
        }
        console.log('payloadObj',payloadObj);
        setShowSpinner(true);
        axios.post(Constants.UPDATE_EVENT_DETAILS, payloadObj).then(() => {
            alert('Data saved');
            // getEvents({date: eventDate});
            getEvents({date: eventDate, toDate: eventToDate});
            setShowPopup(false);
            setShowSpinner(false);
        }).catch((error) => {
            alert('Error saving data', error);
            setShowSpinner(false);
        });
    };

    const openCancelModal = () => {
        setCancelPersonName("");
        setCancelMessage("");
        setCancelModalOpen(true);
    };

    const submitCancelEvent = () => {
        const nameTrim = cancelPersonName.trim();
        const msgTrim = cancelMessage.trim();
        if (!nameTrim) {
            alert("Please enter the name of the person cancelling.");
            return;
        }
        if (!msgTrim) {
            alert("Please enter a cancellation reason / message.");
            return;
        }
        gridRef.current.api.deselectAll();
        setCancelBusy(true);
        axios
            .post(Constants.CANCEL_EVENT, {
                bookRefId: selectedCard.bookingRefId,
                cancelledByPersonName: nameTrim,
                cancellationMessage: msgTrim,
            })
            .then(() => {
                alert("Event cancelled");
                getEvents({ date: eventDate, toDate: eventToDate });
                setShowPopup(false);
                setCancelModalOpen(false);
            })
            .catch((error) => {
                const body = error?.response?.data;
                const msg = body?.message || (typeof body === "string" ? body : null) || error?.message || "Cancel failed.";
                alert(msg);
            })
            .finally(() => setCancelBusy(false));
    };

    const handleClose = () => {
        gridRef.current.api.deselectAll();
        setShowPopup(false);
    };

    const editTheatre = async(e) => {
        setSelectedCard({
            ...selectedCard,
            theatreId: e.target.value,
            slotId: "",
            totalSeats: ''
        });
        await getTimeSlots(+e.target.value);
    }

    const getEvents = (payload) => {
        setShowSpinner(true);
        axios.post(Constants.GET_ALL_EVENTS, payload).then((response) => {
            const list = Array.isArray(response.data) ? response.data : [];
            setData(list.filter((row) => !isFailedOnlinePaymentRow(row)));
            setShowSpinner(false);
        }).catch((error) => {
            console.error('Error fetching data', error);
            setShowSpinner(false);
        });
    }

    useEffect(() => {
        getEvents({date: eventDate, toDate: eventToDate});
        axios.get(Constants.GET_META_DATA_ADDONS)
        .then(response => {
            setFullMetaData(response?.data);
        })
        .catch(error => console.log(error));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load once on mount
    },[]);

    useEffect(() => {
        calculateSeatsPrice();
        calculateAddsOnsPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- derived from selectedCard + timeSlotObj
    },[selectedCard, timeSlotObj]);

    useEffect(() => {
        const matchedSlot = availableTimeSlotData.find(timeslot => timeslot.id === selectedCard.slotId || 1);
        setTimeSlotObj(matchedSlot);
    },[availableTimeSlotData, selectedCard.slotId]);

    const onSearch = () => {
        getEvents({date: eventDate, toDate: eventToDate,theatreId: selectedTheatre ? +selectedTheatre : null, phoneNumber});
    }


    const onExport = () => {
        gridRef.current.api.exportDataAsCsv();
    };

    const getTimeSlots = (theatreId) => {
        axios.post(Constants.GET_THEATERS_LIST, {date: eventDate})
        .then(response => {
            const theatresData = response.data.details;
            const timeSlotsData = theatresData.find(theatre => theatre.id === theatreId).timeslots;
            // console.log('TimeSlot Data', timeSlotsData);
            setAvailableTimeSlotData(timeSlotsData);
        })
        .catch(error => console.log(error));
    }


    const onRowSelection = async () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        if(selectedRows.length > 0) {
            setSelectedCard(selectedRows[0]);
            let advancePaid = selectedRows[0]?.totalAmountPaid;
            setAdvancePaidTillNow(advancePaid);
            console.log('advancePaid :',advancePaid)
            setInitialSelectedSlotId(selectedRows[0].slotId || 1);
            await getTimeSlots(selectedRows[0].theatreId || 1);
            setShowPopup(true);
        }
    }

    const editTimeSlot = (e) => {
        const slotId = e.target.value;
        const selectedSlot = availableTimeSlotData?.find(slot => slot.id === +slotId);
        setTimeSlotObj(selectedSlot);
        setSelectedCard({
            ...selectedCard,
            slotId
        });
    }

    const editEventData = (e, isNumber) => {
        setSelectedCard({
            ...selectedCard,
            [e.target.name]: isNumber ? +e.target.value : e.target.value
        });
    }

    const updatePaymentToPay = (e, isNumber) => {
        let amtToPay = e.target.value;
        let remainingAmt = seatsPrice + addsOnsPrice - advancePaidTillNow;
        console.log('amtToPay before ',remainingAmt);
        // if(amtToPay < remainingAmt){
        //     amtToPay = remainingAmt;
        // }
        console.log('amtToPay after ',amtToPay);
        // if(advancePaidTillNow < amtToPay){
        //     amtToPay = advancePaidTillNow;
        // }
        // if(amtToPay == 0 || amtToPay == '0'){
        //     console.log('in if')
        //     amtToPay = seatsPrice + addsOnsPrice - advancePaidTillNow;
        // }else{
        //     amtToPay = seatsPrice + addsOnsPrice - e.target.value;
        // }
        console.log('amtToPay ',amtToPay);
        if(amtToPay > remainingAmt){
            amtToPay = remainingAmt;
        }
        e.target.value = amtToPay;

        // selectedCard.remainingAmtToPay
        setSelectedCard({
            ...selectedCard,
            [e.target.name]: isNumber ? +e.target.value : e.target.value,
            remainingAmtToPay: remainingAmt
        });
    }

    // value={} 

    const changeMultiSelect = (e, key) => {
        const eventAddons = {...selectedCard.eventAddons};
        eventAddons[key] = e;
        setSelectedCard({
            ...selectedCard,
            eventAddons
        });
    };

    const packageSummary = showPopup ? summarizeBookingPackages(selectedCard) : [];

    const copyPhone = () => {
        const n = selectedCard?.phoneNumber;
        if (n && navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(String(n));
        }
    };

    return (
        <AdminLayout title="PartyBoss">
            {showSpinner && (
           <div className="d-flex justify-content-center align-items-center" style={{position:"fixed",top:"0",left:"0",width:"100%",height:"100%",zIndex:"11000",background:"rgba(0, 0, 0, 0.55)"}}>
              <Spinner animation="border" variant="light" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner></div>
          )}
            <div className="admin-console-card">
                <div className="admin-console-card-title">Filters</div>
                <Form className="admin-console-filters">
                <Form.Group controlId="eventDate">
                    <Form.Label>From date</Form.Label>
                    <AdminDateInput
                        value={eventDate}
                        onChange={(e) => setEventDate(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId="eventToDate">
                    <Form.Label>To date</Form.Label>
                    <AdminDateInput
                        value={eventToDate}
                        onChange={(e) => setEventToDate(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="TheatreName">
                    <Form.Label>Theatre</Form.Label>
                    <Form.Control as="select" value={selectedTheatre} onChange={(e) => setSelectedTheatre(e.target.value)} className="form-select">
                            <option value="">All theatres</option>
                            {
                                fullMetaData?.theatres.map((theatre, index) => {
                                    return <option key={index} value={theatre.id}>{theatre.name}</option>
                                })
                            }
                    </Form.Control>
                </Form.Group>
                <Form.Group controlId="phoneNumber">
                    <Form.Label>Or phone</Form.Label>
                    <Form.Control
                        type="tel"
                        placeholder="10-digit mobile"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                </Form.Group>
                <button type="button" onClick={() => onSearch()} className="admin-console-icon-btn bi bi-search" title="Search" aria-label="Search" />
                <button type="button" onClick={() => onExport()} className="admin-console-icon-btn bi bi-download" title="Export CSV" aria-label="Export CSV" />
                <button
                    type="button"
                    className="admin-console-nav-btn admin-console-nav-btn--primary"
                    onClick={() => navigate('/admin/partyboss-slot-booking')}
                >
                    PartyBoss slot booking
                </button>
                </Form>
            </div>
            <div className="admin-console-card-title px-1">Booking list — select a row to view packages & payment</div>
            <div className="admin-console-grid-wrap admin-console-grid-wrap--light ag-theme-quartz" style={{ height: 520 }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={data}
                    suppressExcelExport={true}
                    columnDefs={tableMeta}
                    rowSelection={"single"}
                    onSelectionChanged={onRowSelection}
                />
            </div>

            {showPopup ?
            <Modal show className="admin-console-modal" contentClassName="border-0 shadow-lg" dialogClassName="modal-dialog modal-lg modal-dialog-scrollable" onHide={handleClose} centered scrollable>
                <Modal.Header closeButton closeVariant="white">
                    <Modal.Title>Booking detail — internal</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="admin-console-section">
                        <div className="admin-console-section-title">Call & identify</div>
                        <div className="admin-console-phone-row">
                            <span className="admin-console-phone">
                                <a href={`tel:${String(selectedCard.phoneNumber || '').replace(/\D/g, '')}`}>
                                    {selectedCard.phoneNumber}
                                </a>
                            </span>
                            <button type="button" className="admin-console-nav-btn" onClick={copyPhone}>Copy number</button>
                        </div>
                        <div className="admin-console-chip-row mt-2">
                            <span className="admin-console-chip">{selectedCard.customerName}</span>
                            <span className="admin-console-chip admin-console-chip--muted">Booking #{selectedCard.bookingRefId}</span>
                            <span className="admin-console-chip admin-console-chip--muted">{selectedCard.status}</span>
                            <span className="admin-console-chip admin-console-chip--muted">
                              Payment:{" "}
                              {(() => {
                                const ps = String(selectedCard.paymentStatus || "").toUpperCase();
                                if (ps === "ADMIN PENDING PAYMENT" || ps === "SAVE NOW PAY LATER") {
                                  return "Save and Pay Later (pending)";
                                }
                                return selectedCard.paymentStatus;
                              })()}
                            </span>
                        </div>
                    </div>

                    <div className="admin-console-section">
                        <div className="admin-console-section-title">Visit snapshot</div>
                        <div className="admin-console-chip-row">
                            <span className="admin-console-chip">{selectedCard.eventDate}</span>
                            <span className="admin-console-chip">{selectedCard.theatreName}</span>
                            <span className="admin-console-chip">{selectedCard.slotName}</span>
                            <span className="admin-console-chip admin-console-chip--muted">{selectedCard.totalSeats} persons</span>
                        </div>
                    </div>

                    <div className="admin-console-section">
                        <div className="admin-console-section-title">Packages & extras (what they chose)</div>
                        {packageSummary.length === 0 ? (
                            <p className="small mb-0" style={{ color: '#94a3b8' }}>No structured add-ons on this row — check grid columns or payment notes.</p>
                        ) : (
                            packageSummary.map((sec) => (
                                <div key={sec.category} className="mb-3">
                                    <div className="fw-bold text-capitalize mb-1" style={{ color: '#d8b4fe' }}>{sec.category}</div>
                                    <ul className="mb-0 ps-3 small" style={{ color: '#e8e3f0' }}>
                                        {sec.items.map((item, ix) => (
                                            <li key={`${sec.category}-${ix}`}>{item}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))
                        )}
                        {(selectedCard.userDirections || selectedCard.nameOnCake) ? (
                            <div className="mt-2 pt-2 border-top border-secondary border-opacity-25">
                                <div className="fw-bold small mb-1" style={{ color: '#ffd166' }}>Customer notes / cake text</div>
                                <div className="small" style={{ color: '#cbd5e1' }}>{selectedCard.userDirections || selectedCard.nameOnCake}</div>
                            </div>
                        ) : null}
                    </div>

                    <div className="admin-console-section-title mb-3 mt-1">Full booking record & payment</div>
                    <Form>
                        <Form.Group controlId="customerName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" value={selectedCard.customerName} name="customerName" disabled='true' onChange={(e) => editEventData(e)}/>
                        </Form.Group>
                        <Form.Group controlId="phoneNumber">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control type="tel" value={selectedCard.phoneNumber} name="phoneNumber" disabled='true' onChange={(e) => editEventData(e)}/>
                        </Form.Group>
                        <Form.Group controlId="bookiingRefId">
                            <Form.Label>Booking Ref Id</Form.Label>
                            <Form.Control type="text" value={selectedCard.bookingRefId} name="bookingRefId" disabled='true' onChange={(e) => editEventData(e)}/>
                        </Form.Group>
                        <Form.Group controlId='eventDate'>
                            <Form.Label>Event Date</Form.Label>
                            <AdminDateInput
                              value={selectedCard.eventDate}
                              name="eventDate"
                              disabled
                              onChange={(e) => changeDate(e)}
                            />
                        </Form.Group>
                        <Form.Group controlId='theatreName'>
                            <Form.Label>Theatre Name</Form.Label>
                            <Form.Control as="select" value={selectedCard.theatreId} name='theatreId' disabled='true' className="form-select" onChange={(e) => editTheatre(e)}>
                                <option value="">--Please choose an option--</option>
                                {
                                    fullMetaData?.theatres.map((theatre, index) => {
                                        return <option key={index} value={theatre.id}>{theatre.name}</option>
                                    })
                                }
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId='slotId'>
                            <Form.Label>Selected Slot</Form.Label>
                            <Form.Control as="select" value={selectedCard.slotId} name='slotId' disabled='true' className="form-select" onChange={(e) => editTimeSlot(e)}>
                                <option value="">--Please choose an option--</option>
                                {
                                    availableTimeSlotData?.map((slot, index) => {
                                        return <option key={index} value={slot.id} disabled={initialSelectedSlotId !== slot.id && !slot.isAvailable}>{slot.slotTime}</option>
                                    })
                                }
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId='eventType'>
                            <Form.Label>Event Type</Form.Label>
                            <Form.Control as="select" value={selectedCard.eventType} name='eventType' disabled='true' className="form-select" onChange={(e) => editEventData(e, true)}>
                                <option value="">--Please choose an option--</option>
                                {
                                    fullMetaData?.eventTypes.map((event, index) => {
                                        return <option key={index} value={event.id}>{event.name}</option>
                                    })
                                }
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId='status'>
                            <Form.Label>Status</Form.Label>
                            <Form.Control as="select" value={selectedCard.status} name='status' disabled='true' className="form-select" onChange={(e) => editEventData(e)}>
                                <option value="">--Please choose an option--</option>
                                {
                                    fullMetaData?.statusList.map((status, index) => {
                                        return <option key={index} value={status.name}>{status.description}</option>
                                    })
                                }
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId='selectedSeats'>
                            <Form.Label>Selected Seats</Form.Label>
                            <Form.Control as="select" value={selectedCard.totalSeats} name='totalSeats' disabled='true' className="form-select" onChange={(e) => editEventData(e, true)}>
                                <option value="">--Please choose an option--</option>
                                {
                                    Array(timeSlotObj?.maxGuests).fill().map((_, index) => {
                                        return <option key={index} value={index+1}>{index+1}</option>
                                    })
                                }
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId='decoration'>
                            <Form.Label>Decoration Details</Form.Label>
                            <Select
                                isMulti={true}
                                disabled={true} 
                                value={selectedCard.eventAddons?.DECORATION}
                                onChange={(e) => changeMultiSelect(e, 'DECORATION')}
                                getOptionLabel={option => option.itemName}
                                getOptionValue={option => option.id}
                                options={fullMetaData?.addonsData?.DECORATION}
                            />
                        </Form.Group>
                        <Form.Group controlId='cake'>
                            <Form.Label>Cake Details</Form.Label>
                            <Select
                                isMulti={true}
                                value={selectedCard.eventAddons?.CAKES}
                                onChange={(e) => changeMultiSelect(e, 'CAKES')}
                                getOptionLabel={option => option.itemName}
                                getOptionValue={option => option.id}
                                options={fullMetaData?.addonsData?.CAKES}
                            />
                        </Form.Group>
                        <Form.Group controlId='flower'>
                            <Form.Label>Flower Details</Form.Label>
                            <Select
                                isMulti={true}
                                value={selectedCard.eventAddons?.FLOWERS}
                                onChange={(e) => changeMultiSelect(e, 'FLOWERS')}
                                getOptionLabel={option => option.itemName}
                                getOptionValue={option => option.id}
                                options={fullMetaData?.addonsData?.FLOWERS}
                            />
                        </Form.Group>
                        <Form.Group controlId='photos'>
                        <Form.Label>Photos Details</Form.Label>
                            <Select
                                isMulti={true}
                                value={selectedCard.eventAddons?.PHOTOS}
                                onChange={(e) => changeMultiSelect(e, 'PHOTOS')}
                                getOptionLabel={option => option.itemName}
                                getOptionValue={option => option.id}
                                options={fullMetaData?.addonsData?.PHOTOS}
                            />
                        </Form.Group>
                        <Form.Group controlId='partyProps'>
                            <Form.Label>Party Props</Form.Label>
                            <Select
                                isMulti={true}
                                value={selectedCard.eventAddons?.['PARTY PROPS']}
                                onChange={(e) => changeMultiSelect(e, 'PARTY PROPS')}
                                getOptionLabel={option => option.itemName}
                                getOptionValue={option => option.id}
                                options={fullMetaData?.addonsData?.['PARTY PROPS']}
                            />
                        </Form.Group>
                        <Form.Group controlId='notes'>
                            <Form.Label>Customer Notes</Form.Label>
                            <Form.Control as="textarea" rows={3} value={selectedCard.userDirections} disabled='true' name="userDirections" onChange={(e) => editEventData(e)}/>
                        </Form.Group>
                        <Form.Group controlId="totalAmount">
                            <Form.Label>Total Invoice Amount</Form.Label>
                            <Form.Control type="text" value={seatsPrice + addsOnsPrice} disabled/>
                        </Form.Group>
                        <Form.Group controlId="price">
                            <div style={{display: 'flex'}}>
                            <div style={{flex: '1'}} ><Form.Label>Seats Price :</Form.Label> <span><b> {seatsPrice} </b></span></div>
                            <div style={{flex: '1'}} ><Form.Label>Addons Price :</Form.Label> <span><b> {addsOnsPrice} </b></span></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="advance">
                            <Form.Label>Advance Paid (Till now : {advancePaidTillNow} )</Form.Label>
                            <Form.Control type="text" value={selectedCard.totalAmountPaid} name="totalAmountPaid" 
                                onChange={(e) => updatePaymentToPay(e, true)}/>
                        </Form.Group>
                        <Form.Group controlId="finalPaymentToPay">
                            <Form.Label>Remaining Amount to be Paid</Form.Label>
                            <Form.Control
                                type="text"
                                disabled
                                value={selectedCard.remainingAmtToPay}
                                name="finalAmountPaid"
                            />
                        </Form.Group>
                        <Form.Group controlId='paymentMode'>
                            <Form.Label>Payment Mode</Form.Label>
                            <Form.Control as="select" value={selectedCard.paymentMode} name='paymentMode' className="form-select" 
                                    onChange={(e) => editEventData(e, false)}>
                                <option value="">--Please choose an option--</option>
                                <option value="PENDING">Pending</option>
                                <option value="Bank">Bank</option>
                                <option value="Cash">Cash</option>
                                <option value="OFFLINE">OFFLINE</option>
                                
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="cancellation">
                            <Form.Label>Cancellation Charges</Form.Label>
                            <Form.Control type="text" disabled='true' value={selectedCard.cancellationCharges} name="cancellationCharges" onChange={(e) => editEventData(e, true)}/>
                        </Form.Group>
                        <Form.Group controlId='adminNotes'>
                            <Form.Label>Admin Notes</Form.Label>
                            <Form.Control as="textarea" disabled='true' rows={3} value={selectedCard.adminNotes} name="adminNotes" onChange={(e) => editEventData(e)}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleSave()}>
                        Save
                    </Button>
                    <Button variant="danger" disabled={cancelBusy} onClick={() => openCancelModal()}>
                        Cancel Event
                    </Button>
                    <Button variant="secondary" onClick={() => handleClose()}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal> : null}
            {cancelModalOpen ? (
                <Modal show={cancelModalOpen} onHide={() => !cancelBusy && setCancelModalOpen(false)} backdrop="static" centered className="text-start">
                    <Modal.Header closeButton={!cancelBusy}>
                        <Modal.Title className="h5">Confirm cancellation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="small text-muted">Both fields are required and are recorded for booking analytics audits.</p>
                        <Form.Group className="mb-2">
                            <Form.Label>Name of person cancelling</Form.Label>
                            <Form.Control
                                value={cancelPersonName}
                                onChange={(e) => setCancelPersonName(e.target.value)}
                                placeholder="Staff or authorised contact name"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Cancellation message / reason</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={cancelMessage}
                                onChange={(e) => setCancelMessage(e.target.value)}
                                placeholder="Brief reason communicated to ops / finance"
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" disabled={cancelBusy} onClick={() => setCancelModalOpen(false)}>
                            Back
                        </Button>
                        <Button variant="danger" disabled={cancelBusy} onClick={submitCancelEvent}>
                            {cancelBusy ? "Cancelling…" : "Confirm cancel booking"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            ) : null}
        </AdminLayout>
    );
};

export default AdminDashboard;
